import styled from 'styled-components';

import MotifPagination from '@ey/motif-react-wrapper/Pagination';

export default styled(MotifPagination)`
	&.motif-pagination {
		font-size: 14px;
		.motif-pagination-count {
			.motif-number-of-pages {
				.ref-input-elem {
					display: inline;
					visibility: unset;
					border: none;
					position: static;
					background: none;
				}
				.motif-pagination-current-page {
					display: none;
				}
			}
		}

		.motif-icon-button {
			--size: 3.2rem;
			height: var(--size);
			svg {
				height: var(--size);
				width: var(--size);
				flex-shrink: 0;
				margin: 0;
			}
			&:disabled svg path {
				fill: var(--disabled);
			}
		}
		button:not(.motif-dropdown-trigger) .motif-icon-button {
			width: var(--size);
		}
		*,
		.motif-pagination-select .motif-dropdown-trigger .motif-icon-button {
			font-size: inherit;
		}

		&.open-top {
			.motif-dropdown-menu {
				bottom: 100%;
				top: unset !important;
			}
			.motif-pagination-select {
				svg {
					transform: rotate(180deg);
				}
				&.motif-dropdown-open {
					svg {
						transform: none;
					}
				}
			}
		}
	}
`;
